const resources = {
    callUs: 'Call Us',
    phone: '1-877-SEPHORA (1-877-737-4672)',
    phoneLocation: '(U.S. or Canada)',
    hearingImpaired: 'Hearing Impaired/TTY',
    phoneTTY: '1-888-866-9845',
    rougePrivate: 'Rouge Private Hotline',
    rougePhone: '1-855-55-ROUGE',
    rougePhoneFull: '(1-855-557-6843)',
    representative: 'Representatives or Beauty Advisors are available:',
    monFri: 'MON-FRI',
    monFriTime: '5am - 9pm PT',
    satSun: 'SAT-SUN',
    satSunTime: '6am - 9pm PT'
};

module.exports = function getResource(label) {
    return resources[label];
};
